import { peopleMasterSeed } from './people';

/** In-memory People Master store (UI mock — shared by list + detail). */
let people = peopleMasterSeed.map((p) => ({ ...p }));

export function getPeople() {
  return people;
}

export function setPeople(next) {
  people = next;
}

export function addPerson(person) {
  people = [...people, person];
  return person;
}

export function findPersonById(peopleId) {
  return people.find((p) => p.peopleId === peopleId) || null;
}

export function updatePerson(peopleId, patch) {
  people = people.map((p) =>
    p.peopleId === peopleId ? { ...p, ...patch, peopleId: p.peopleId } : p,
  );
  return findPersonById(peopleId);
}
